import type { FaireProductEntity } from "../../entity_types/product";

export const p_y2gxjrtk4r: FaireProductEntity = {
  token: "p_y2gxjrtk4r",
  type: "product",
  name: "Wine Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/6cb2c82e76831477bd5d958d25e7a42e90bfe4860a6e4b7f274b0c0fcafd511e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e11514ca158404ccf91b1521f8c333411f046dff20636686eac727c2d38b9e4.jpeg",
    "https://cdn.faire.com/fastly/acf16f08979b852247e938f1cd74d87341a50f6de4aa9469f703bf122742450d.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/12a72b85c987fb195f89de2ba2947343061fd8ace9d2274ccb7bc7dbb012595e.jpeg"
  ],
  priceDollars: 6.75,
  description: "For anyone who can swirl it around, claim to taste “notes of leather” and genuinely believes they're not full of it. Take them to the vineyard in these comfy, honest socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:53.031Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
